document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".quick-cart-btn");
  cartBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      btn.setAttribute("src", "#");
    });
  });


  const reviewsCount = document.querySelectorAll(".jdgm-rating-text");
  const reviews2Count = document.querySelectorAll(".jdgm-rev-widg__summary-text");
  reviewsCount.forEach((count) => {
    count.innerHTML = count.innerHTML.replaceAll("(", "").replaceAll(")", "");
  });
  reviews2Count.forEach((count) => {
    count.innerHTML = "";
  });
});
